module.exports = __webpack_public_path__ + "img/logo-dark.16101797.png";